<ng-container *ngIf="productShortcuts$ | async as productShortcuts">
  @if (hasVisibleEntries(productShortcuts)) {
    <ul>
      <ng-container *ngFor="let shortcut of productShortcuts.shortcuts">
        @if (shortcut.visible) {
          <li class="shotcut">
            <button class="btn btn-outline-secondary btn-sm" (click)="scrollToSection(shortcut.targetUID)">
              <span *ngIf="shortcut.icon" class="material-symbols-outlined d-flex m-r-4"> {{ shortcut.icon }} </span>

              {{ shortcut.label }}
            </button>
          </li>
        }
      </ng-container>
    </ul>
  }
</ng-container>
